import { render, staticRenderFns } from "./Datagraph6.vue?vue&type=template&id=78264ecc&scoped=true"
import script from "./Datagraph6.vue?vue&type=script&setup=true&lang=js"
export * from "./Datagraph6.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78264ecc",
  null
  
)

export default component.exports